/**
 * Created by kj on 2020/12/12.
 */
import ajaxHealthy from './fetch-healthy.js'
export default {
  /**
   * [获取健康码]
   * @returns
   */
  sGetHealthy (params) {
    return ajaxHealthy({
      url: 'user/api/smart/travel/health/getHealthInfo',
      type: 'get',
      params: Object.assign({...params})
    })
  }
}



// WEBPACK FOOTER //
// ./src/service/healthy.js